<template>
  <div>
    <fragment>
      <c-hero-full
        has-bg-color
        invert-color
        class="illustration-section-01"
        @openSignupModal="demoModalActive = true"
      />
      <c-features-tiles />
      <!-- <c-features-split top-divider invert-mobile image-fill /> -->
      <!-- <c-testimonial top-divider /> -->
      <c-cta has-bg-color invert-color split @openSignupModal="demoModalActive = true" />
    </fragment>
    <c-modal id="demo-modal" :active.sync="demoModalActive">
      <div class="center-content">
        <h3 class="mt-0 mb-12">We're Launching Soon.</h3>
        <p
          class="mb-32"
        >Get notified - and get exclusive launch pricing - as soon as we're ready for you.</p>

        <mailchimp-subscribe
          url="https://coachulous.us2.list-manage.com/subscribe/post-json"
          user-id="3d43ea3fc9e891c0aaefbad32"
          list-id="5b537ab53a"
          @error="onError"
          @success="onSuccess"
        >
          <template v-slot="{ subscribe, setEmail, error, success, loading }">
            <form @submit.prevent="subscribe">
              <!-- <input type="email" @input="setEmail($event.target.value)" /> -->
              <c-input
                ref="emailAddress"
                type="email"
                placeholder="you@youremail.com"
                form-group="desktop"
                label-hidden
                @input="setEmail($event)" 
              >
              <c-button
                ref="subscribeButton"
                color="primary"
                @click.prevent="subscribe"
                :loading="signupState=='inprogress'"
              >Subscribe</c-button>
              </c-input>
              <div class="error" v-if="error" v-html="error"></div>
              <div class="success" v-if="success">Signed up successfully - thank you!</div>
              <div v-if="loading">Loading…</div>
            </form>
          </template>
        </mailchimp-subscribe>
      </div>
    </c-modal>
  </div>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutDefault.vue";
// import sections
import CHeroFull from "@/components/sections/HeroFull.vue";
import CFeaturesTiles from "@/components/sections/FeaturesTiles.vue";
// import CFeaturesSplit from '@/components/sections/FeaturesSplit.vue'
// import CTestimonial from '@/components/sections/Testimonial.vue'
import CCta from "@/components/sections/Cta.vue";
import CModal from "@/components/elements/Modal.vue";
import CInput from "@/components/elements/Input.vue";
import CButton from "@/components/elements/Button.vue";
import MailchimpSubscribe from 'vue-mailchimp-subscribe'


export default {
  name: "Home",
  components: {
    CHeroFull,
    CFeaturesTiles,
    // CFeaturesSplit,
    // CTestimonial,
    CCta,
    CModal,
    CInput,
    CButton,
    MailchimpSubscribe
  },
  data() {
    return {
      demoModalActive: false,
      signupState: "ready"
    };
  },
  methods: {
    handleInput: function($evt){
      console.log($evt); //setEmail(vaal)
    },
    onError() {
      // handle error
    },
    onSuccess() {
      // handle success
    },
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>
<style scoped>
  .error{
    font-size: 12px;
    color: red;
    line-height: 18px;
  }
  .success{
    color: green;
  }
</style>
